import { createElement } from 'react';

const KaizenLogoOnly = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24.5 19.0586H0.5V23.9998H24.5V19.0586Z" fill="white" />
    <path
      d="M22.1 0H17.3V2.4299H20.4674L9.53134 13.5022L0.5 4.35524V7.79424L9.5344 16.9412L11.2312 15.2232L11.2282 15.2201L22.1 4.21285V7.28969H24.5V2.4299V0H22.1Z"
      fill="#2DD28D"
    />
  </svg>
);

export default KaizenLogoOnly;
